/* unplugin-vue-components disabled */import script from "./merchandise-modal-v2.vue?vue&type=script&setup=true&lang=js"
export * from "./merchandise-modal-v2.vue?vue&type=script&setup=true&lang=js"

import "./merchandise-modal-v2.vue?vue&type=style&index=0&id=3f2ee534&lang=scss"

const __exports__ = script;

export default __exports__